// extracted by mini-css-extract-plugin
export var alignBaseline = "_8-9";
export var alignCenter = "_8-5";
export var alignFlexEnd = "_8-7";
export var alignFlexStart = "_8-6";
export var alignSelfBaseline = "_8-e";
export var alignSelfCenter = "_8-a";
export var alignSelfFlexEnd = "_8-c";
export var alignSelfFlexStart = "_8-b";
export var alignSelfStretch = "_8-d";
export var alignStretch = "_8-8";
export var column = "_8-2";
export var columnReverse = "_8-4";
export var flex = "_8-0";
export var justifyCenter = "_8-f";
export var justifyFlexEnd = "_8-h";
export var justifyFlexStart = "_8-g";
export var justifySpaceAround = "_8-j";
export var justifySpaceBetween = "_8-i";
export var justifySpaceEvenly = "_8-k";
export var row = "_8-1";
export var rowReverse = "_8-3";
export var wrapNowrap = "_8-m";
export var wrapWrap = "_8-l";
export var wrapWrapReverse = "_8-n";